import { render, staticRenderFns } from "./BatchRunReplicaTable.vue?vue&type=template&id=1f0abe84&scoped=true"
import script from "./BatchRunReplicaTable.vue?vue&type=script&lang=js"
export * from "./BatchRunReplicaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0abe84",
  null
  
)

export default component.exports